import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { delay, filter, map, switchMap, takeUntil, tap } from 'rxjs';

import { SidebarCustomComponents } from '../../domain/constants/sidebar-custom-components';
import { SidebarCommandsFacade } from '../commands/sidebar.commands.facade';
import { CloseSidebarCustom, LoadSidebar } from '../state/sidebar.actions';

@Injectable()
export abstract class SidebarPopupEffects {
    constructor(
        protected readonly actions$: Actions,
        protected readonly store: Store,
        protected readonly router: Router,
    ) { }

    protected readonly abstract sidebarComponent: SidebarCustomComponents;

    public loadSidebar$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadSidebar),
            filter(({ component }) => component === this.sidebarComponent),
            tap(({ component, data, initializeFunction }) => {
                new SidebarCommandsFacade(this.store).openSidebarCustom({
                    component, data, initializeFunction,
                });
            })
        );
    }, { dispatch: false });

    public closeSidebar$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadSidebar),
            filter(({ component }) => component === this.sidebarComponent),
            switchMap(() => this.actions$.pipe(
                ofType(CloseSidebarCustom),
            )),
            tap(() => {
                this.router.navigate([], { replaceUrl: true });
            })
        );
    }, { dispatch: false });

    public routeCloseSidebar$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadSidebar),
            filter(({ component }) => component === this.sidebarComponent),
            delay(0),
            switchMap(() => this.actions$.pipe(
                ofType(ROUTER_NAVIGATED),
                takeUntil(this.actions$.pipe(ofType(CloseSidebarCustom)))
            )),
            map(() => CloseSidebarCustom({}))
        );
    });
}
